// extracted by mini-css-extract-plugin
export default {"summaryRow":"summaryRow__fj7n8","overline":"overline__1LIlM"};